export default __webpack_public_path__ + "static/media/primaafphero.b4db0bcc.jpg";